import React, { useEffect } from 'react';
import './BallEffect.css';

const SectionVideo1 = () => {
  useEffect(() => {
    const handleMouseMove = (e) => {
      document.body.style.setProperty('--mx', e.clientX - window.innerWidth / 2);
      document.body.style.setProperty('--my', e.clientY - window.innerHeight / 2);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const renderBalls = () =>
    Array.from({ length: 12 }, (_, i) => (
      <div key={i} className="ball" style={{ '--i': i }}></div>
    ));

  const renderShadows = () =>
    Array.from({ length: 12 }, (_, i) => (
      <div key={i} className="shadow" style={{ '--i': i }}></div>
    ));

  return (
    <>
      <div className="baseLight" />
      <div className="center-label">Azown</div>
      <div className="shadows">{renderShadows()}</div>
      <div className="balls">{renderBalls()}</div>
    </>
  );
};

export default SectionVideo1;
